import React from 'react'
import {
  type MappingListItem,
  useGetTenantCommodityMappingDetails,
} from 'src/api/queries/microservices/platform-markets-commodity-config'
import { Button, Placeholders } from 'src/ui'
import MappingEditorForm from './platform-commodity-mapping-editor-form'

type MappingEditorProps = {
  commodity: MappingListItem
  tenantId: string
  canEdit: boolean
  onClose: () => void
}

export default function MappingEditor({
  commodity,
  tenantId,
  canEdit,
  onClose,
}: MappingEditorProps) {
  const detailsQuery = useGetTenantCommodityMappingDetails(commodity.commodityId)

  if (detailsQuery.isPending) return <Placeholders.LoadingState mt={8} />
  if (detailsQuery.isError || !detailsQuery.data) {
    return (
      <>
        <Placeholders.FailedState mt={8} />
        <Button display="block" mx="auto" onClick={onClose}>
          Back to mappings
        </Button>
      </>
    )
  }

  return (
    <MappingEditorForm
      key={commodity.commodityId}
      mapping={detailsQuery.data}
      tenantId={tenantId}
      canEdit={canEdit}
      onClose={onClose}
    />
  )
}
